import { render, staticRenderFns } from "./Collapsable.vue?vue&type=template&id=65023225&"
import script from "./Collapsable.vue?vue&type=script&lang=ts&"
export * from "./Collapsable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports